<template>
  <!-- Spade -->
  <svg
    v-if="activeShape === 'spade'"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    height="auto"
    viewBox="0 0 24 24"
    :fill="fillColor"
    :stroke="strokeColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="inline-loader"
  >
    <path d="M12 18v4" />
    <path d="M2 14.499a5.5 5.5 0 0 0 9.591 3.675.6.6 0 0 1 .818.001A5.5 5.5 0 0 0 22 14.5c0-2.29-1.5-4-3-5.5l-5.492-5.312a2 2 0 0 0-3-.02L5 8.999c-1.5 1.5-3 3.2-3 5.5" />
  </svg>

  <!-- Club -->
  <svg
    v-if="activeShape === 'club'"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    height="auto"
    viewBox="0 0 24 24"
    :fill="fillColor"
    :stroke="strokeColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="inline-loader"
  >
    <path d="M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z" />
    <path d="M12 17.66L12 22" />
  </svg>

  <!-- Diamond -->
  <svg
    v-if="activeShape === 'diamond'"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    height="auto"
    viewBox="0 0 24 24"
    :fill="fillColor"
    :stroke="strokeColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="inline-loader"
  >
    <path d="M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41l-7.59-7.59a2.41 2.41 0 0 0-3.41 0Z" />
  </svg>

  <!-- Love -->
  <svg
    v-if="activeShape === 'love'"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    height="auto"
    viewBox="0 0 24 24"
    :fill="fillColor"
    :stroke="strokeColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="inline-loader"
  >
    <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const allShapes = ['spade', 'club', 'diamond', 'love'] as const
const {
  size = 18,
  shape = 'spade',
  strokeColor = 'currentColor',
  strokeWidth = 3,
  fillColor = 'none',
  randomize = true
} = defineProps<{
  size?: number
  shape?: (typeof allShapes)[number]
  strokeColor?: string
  fillColor?: string
  strokeWidth?: number
  randomize?: boolean
}>()

const activeShape = computed(() => {
  if (randomize) {
    const randomIndex = Math.floor(Math.random() * allShapes.length)
    return allShapes[randomIndex]
  }
  return shape
})
</script>

<style scoped>
.inline-loader {
  transform-origin: center;
  animation: flipY 1s linear infinite;
  /* Improve rendering on some browsers */
  /* backface-visibility: hidden; */
  will-change: transform;
}

@keyframes flipY {
  0% {
    transform: rotate3d(0, 1, 0, 0deg);
  }
  50% {
    transform: rotate3d(0, 1, 0, 180deg);
  }
  100% {
    transform: rotate3d(0, 1, 0, 360deg);
  }
}
</style>
